var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-container"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.list,"loading":_vm.loading,"noDataText":`<div class='no_data'>
      <img  src='${require('@/assets/images/no-data.png')}'>
    <span class='text'> ${_vm.$t('暂无记录')} </span>
</div>`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }